import type { ActivityEventType } from '@pay888/shared';

export function getActivityEventLabel(eventType: ActivityEventType): string {
  switch (eventType) {
    case 'payment_link_created':
      return 'Payment Link Created';
    case 'payment_link_updated':
      return 'Payment Link Updated';
    case 'payment_link_visibility_changed':
      return 'Visibility Changed';
    case 'payment_link_deactivated':
      return 'Payment Link Deactivated';
    case 'payment_link_deleted':
      return 'Payment Link Deleted';
    default:
      return 'Payment Link Event';
  }
}
